import Flickity from 'flickity';
import 'flickity-fullscreen';
import 'flickity-fade';

export function featuredCarouselv2(el) {
  const playTimers = new WeakMap();
  let flkty;

  function getActiveVideo(cell) {
    const isMobile = window.matchMedia('(max-width: 766px)').matches;
    const videos = [...cell.querySelectorAll('video.fcv2-media__video')];
    if (videos.length <= 1) return videos[0] || null;
    if (isMobile) return videos.find(v => !v.classList.contains('mobile-hidden')) || videos[0];
    return videos.find(v => !v.classList.contains('desktop-hidden')) || videos[0];
  }

  function resetAllSlides() {
    el.querySelectorAll('.flickity-cell').forEach(cell => {
      if (playTimers.has(cell)) {
        clearTimeout(playTimers.get(cell));
        playTimers.delete(cell);
      }
      const posters = cell.querySelectorAll('.fcv2-media__poster');
      const content = cell.querySelector('.fcv2-content__container');

      cell.querySelectorAll('video.fcv2-media__video').forEach(video => {
        video.pause();
        video.currentTime = 0;
        video.style.display = 'none';
        video.style.opacity = 0;
      });
      posters.forEach(img => {
        img.style.display = '';
        void img.offsetWidth;
        img.style.opacity = 1;
      });
      if (content) {
        content.style.display = 'none';
        content.style.opacity = 0;
      }
    });
  }

  function loadVideoSources(video) {
    if (!video || video.dataset.loaded) return;
    let found = false;

    video.querySelectorAll('source[data-src]').forEach(src => {
      src.src = src.dataset.src;
      delete src.dataset.src;
      found = true;
    });

    const { mp4, webm } = video.dataset;
    if (!found && (mp4 || webm)) {
      if (mp4) {
        const s1 = document.createElement('source'); s1.src = mp4; s1.type = 'video/mp4';
        video.appendChild(s1);
      }
      if (webm) {
        const s2 = document.createElement('source'); s2.src = webm; s2.type = 'video/webm';
        video.appendChild(s2);
      }
    }

    video.dataset.loaded = 'true';
    video.preload = 'auto';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.load();
  }

  function attemptPlay(video) {
    video.muted = true;
    video.autoplay = true;
    const promise = video.play();
    if (promise && promise.catch) promise.catch(err => console.debug('[Carousel] play error', err));
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const cell = entry.target;
      const content = cell.querySelector('.fcv2-content__container');

      if (!entry.isIntersecting) {
        // hide video/poster/content
        if (playTimers.has(cell)) {
          clearTimeout(playTimers.get(cell));
          playTimers.delete(cell);
        }
        const posters = cell.querySelectorAll('.fcv2-media__poster');
        cell.querySelectorAll('video.fcv2-media__video').forEach(video => {
          video.pause();
          video.currentTime = 0;
          video.style.display = 'none';
          video.style.opacity = 0;
        });
        posters.forEach(img => {
          img.style.display = '';
          void img.offsetWidth;
          img.style.opacity = 1;
        });
        if (content) {
          content.style.display = 'none';
          content.style.opacity = 0;
        }
      } else if (entry.isIntersecting && flkty && flkty.selectedElement === cell) {
        if (content) {
          content.style.display = '';
          void content.offsetWidth;
          content.style.opacity = 1;
        }
      }
    });
  }, { threshold: 0.1 });

  flkty = new Flickity(el, {
    draggable: true,
    pageDots: true,
    prevNextButtons: true,
    wrapAround: true,
    adaptiveHeight: true,
    fade: true,
    fullscreen: true,
    on: {
      ready() {
        this.cells.forEach(cell => observer.observe(cell.element));
        resetAllSlides();
        handleVideoForSelected(this.selectedElement);
        // Move prev/next buttons into page dots
        const dots = el.querySelector('.flickity-page-dots');
        if (dots && this.prevButton.element && this.nextButton.element) {
          dots.insertBefore(this.prevButton.element, dots.firstChild);
          dots.appendChild(this.nextButton.element);
        }
      }
    }
  });

  function handleVideoForSelected(cell) {
    resetAllSlides();
    const video = getActiveVideo(cell);
    const posters = cell.querySelectorAll('.fcv2-media__poster');
    const content = cell.querySelector('.fcv2-content__container');

    if (content) {
      content.style.display = '';
      void content.offsetWidth;
      content.style.opacity = 1;
    }

    if (video) {
      loadVideoSources(video);
      if (video.readyState >= 2) {
        attemptPlay(video);
      } else {
        video.addEventListener('loadeddata', () => attemptPlay(video), { once: true });
      }
      const timer = setTimeout(() => {
        posters.forEach(img => img.style.opacity = 0);
        video.style.display = '';
        void video.offsetWidth;
        video.style.opacity = 1;
        attemptPlay(video);
        setTimeout(() => posters.forEach(img => img.style.display = 'none'), 800);
        video.onended = () => flkty.next();
      }, 3000);
      playTimers.set(cell, timer);
    } else {
      const timer = setTimeout(() => flkty.next(), 4000);
      playTimers.set(cell, timer);
    }
  }

  flkty.on('change', () => handleVideoForSelected(flkty.selectedElement));
  flkty.on('settle', () => {
    el.querySelectorAll('.fcv2-content__container').forEach(c => {
      c.style.display = 'none';
      c.style.opacity = 0;
    });
    const curr = flkty.selectedElement.querySelector('.fcv2-content__container');
    if (curr) {
      curr.style.display = '';
      void curr.offsetWidth;
      curr.style.opacity = 1;
    }
  });
}
